package com.hyperether.goodjob.managers

actual class NetworkManager {
    actual fun isConnected(): Boolean {
        return true
    }
}